import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { lighten } from '@material-ui/core';
import { Theme } from 'styles/ThemeTyping';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

interface Props {
  title: string;
  imageSource: string;
  className: string;
  onClick: () => void;
}

function DialogSelectItem({ title, imageSource, className, onClick }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <img src={imageSource} alt="Modern Org Chart Card" className={className} />

        <div className={classes.buttonContainer}>
          <Typography variant="body1" className={classes.title}>
            {title}
          </Typography>

          <Button variant="contained" color="secondary" onClick={onClick}>
            Configure
          </Button>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 400,
    width: '100%',
    maxWidth: 350,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    border: `1px solid ${lighten(theme.palette.secondary.main, 0.75)}`,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 0,
  },
  title: {
    display: 'flex',
    fontWeight: theme.typography.fontWeightSemiBold,
    marginBottom: theme.spacing(3),
  },
}));

export default DialogSelectItem;
